import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/be8b1e50-1da2-4fbe-b5bd-1e078dade9fa";
export const REGISTER_URL = "https://a.ntrk2.com/90355c4f-cdb7-4b24-92ad-efe2010d5da5";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://my456.kzw2a.com/download?openExternalBrowser=1&id=xdkq4xafw51efxc";

export * from "./codes";
export * from "./context";
